import { render, staticRenderFns } from "./FBtn.vue?vue&type=template&id=fc4c6b4a&scoped=true&"
import script from "./FBtn.vue?vue&type=script&lang=ts&"
export * from "./FBtn.vue?vue&type=script&lang=ts&"
import style0 from "./FBtn.vue?vue&type=style&index=0&id=fc4c6b4a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4c6b4a",
  null
  
)

export default component.exports